import { useCallback } from 'react';
import { useStore } from 'react-redux';
import Context from 'managers/Context';
import {
    MARKETING_STATUS,
    fetchMarketingStatusList,
    resolveMarketingStatusIdFromList,
} from 'components/TableCells/MarketingStatusCell';
import { isEmpty } from 'utils/isEmpty';

function getSelectionIds(entityListSelect) {
    const selected = entityListSelect?.selected || {};
    const hasFilterSelection = entityListSelect?.hasFilterSelection;
    let includedIds = [];
    let excludedIds = [];
    if (!isEmpty(selected)) {
        Object.keys(selected).forEach((key) => {
            if (selected[key] && !hasFilterSelection) includedIds.push(key);
            else if (selected[key] === false) excludedIds.push(key);
        });
    }
    return [includedIds, excludedIds];
}

function getSelectionFilters(state, entity) {
    const entityListSelect = state.entityListSelect[entity.entity];
    let filter = {};
    if (entityListSelect?.hasFilterSelection) {
        filter = Context.actions.EntityFiltersActions.getCleanFilters(state, entity);
    }
    const operators = Context.actions.EntityFiltersActions.getCleanOperators(state, entity);
    const crossFilters = Context.actions.EntityFiltersActions.getCleanCrossFilters(entity);
    return { crossFilters, filter, operators };
}

export default function useGiveConsent() {
    const store = useStore();

    const giveConsent = useCallback(
        (entity) => {
            const state = store.getState();
            const entityListSelect = state.entityListSelect[entity.entity];
            const [includedIds, excludedIds] = getSelectionIds(entityListSelect);
            const { crossFilters, filter, operators } = getSelectionFilters(state, entity);

            const runBulk = (subscribedId) =>
                Context.bulkManager.startBulk({
                    entityName: entity.extraFieldTab.toLowerCase(),
                    operation: 'update',
                    data: JSON.stringify({
                        marketingStatusId: subscribedId,
                    }),
                    includedIds,
                    excludedIds,
                    filter,
                    operators,
                    crossFilters,
                });

            return fetchMarketingStatusList(store.dispatch).then((rows) =>
                runBulk(resolveMarketingStatusIdFromList(rows, MARKETING_STATUS.SUBSCRIBED)),
            );
        },
        [store],
    );

    return giveConsent;
}
